/**
 * @voltxampere/ui — SelectTool (Sprint 12)
 *
 * Default canvas tool. Hover feedback updates the `hoveredNode`
 * signal as the cursor moves over a hittable scene node; click
 * sets selection. Shift / Cmd / Ctrl modifier toggles the clicked
 * node into / out of the multi-select set.
 *
 * Sprint 13 will extend this with rubber-band drag (selection
 * rectangle) when the cursor lands on void and is dragged. Sprint
 * 12 keeps it minimal — no marquee, no drag.
 *
 * Sprint 25 R5 R5-CR-2 — adds keyboard `Escape` handler that
 * clears the active selection (and the hover affordance, when set).
 * Mirrors WireTool/EraseTool/StampTool/AnnotationTool/RubberBandTool
 * cancel-on-Escape pattern. v1 prototype's `keyboard.js` handled
 * this at the global level; v3 routes it through the active tool.
 * See `tools/triage/reports/TRIAGE_R5CR2_PIN_CLICK.md` §5 Seçenek A.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { toggleSelection } from "./base.js";
export class SelectTool {
    id = "select";
    cursor = "default";
    onPointerMove(e, ctx) {
        const world = ctx.worldFromEvent(e);
        const hit = ctx.hitTester.hit(world);
        const previous = ctx.hoveredNode.value;
        if (previous === hit)
            return;
        if (previous?.id === hit?.id)
            return;
        ctx.hoveredNode.value = hit;
        ctx.invalidate();
    }
    onPointerDown(e, ctx) {
        if (e.button !== 0)
            return; // left click only
        const world = ctx.worldFromEvent(e);
        const hit = ctx.hitTester.hit(world);
        const additive = e.shiftKey || e.metaKey || e.ctrlKey;
        if (hit === null) {
            // Empty space: modifier-less click clears selection;
            // modified click leaves the set as-is (Sprint 13 will start
            // a rubber-band drag here).
            if (!additive && ctx.selectedNodes.value.length > 0) {
                ctx.selectedNodes.value = [];
                ctx.invalidate();
            }
            return;
        }
        if (additive) {
            ctx.selectedNodes.value = toggleSelection(ctx.selectedNodes.value, hit.id);
        }
        else {
            ctx.selectedNodes.value = [hit.id];
        }
        ctx.invalidate();
    }
    onKeyDown(e, ctx) {
        if (e.key === "Escape") {
            if (ctx.selectedNodes.value.length > 0) {
                ctx.selectedNodes.value = [];
                ctx.invalidate();
                if (ctx.hoveredNode.value !== null) {
                    ctx.hoveredNode.value = null;
                }
            }
            e.preventDefault();
        }
    }
    onLeave(ctx) {
        if (ctx.hoveredNode.value !== null) {
            ctx.hoveredNode.value = null;
            ctx.invalidate();
        }
    }
}
//# sourceMappingURL=select.js.map